import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  IconButton,
  Typography,
  TextField,
  useMediaQuery,
  Modal,
  Divider,
  Tooltip,
} from "@mui/material";

import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";

import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ShareIcon from "@mui/icons-material/Share";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import CloseIcon from "@mui/icons-material/Close";
import Popover from "@mui/material/Popover";

import logo from "../../assets/images/logoman.png";
import PostDetalPage from "../popUp/PostDetailPage";
import { EmojiEmotions, MoreVertOutlined } from "@mui/icons-material";
import CustomPopover from "../popUp/CustomPopOver";
import CustomConfirmation from "../popUp/CustomConfirmation";
import { enqueueSnackbar } from "notistack";
import EmojiPicker from "emoji-picker-react";
import {
  handle_get_time_ago,
  htmlDecode,
  is_small_screen,
  show_proper_words,
} from "../../utils/Constant";
import moment from "moment";
import { s3baseUri, project_mode } from "../../config/config";
import FeedImagesList from "../../pages/post/PostImageList";
import ReactVideoPlayer from "../player/ReactVideoPlayer";
import { useIds } from "../../hook/AdminContext";
import {
  csvImage,
  docImage,
  pdfImage,
  wordImage,
  audioImage,
  xlsxImage,
  otherImage,
  liked_counts_icon,
  like_icon,
  liked_icon,
  comment_icon,
  share_icon,
} from "../../assets";
import LinkPreview from "../previewUrl/PreviewsUrl";
import PreviewPostCard from "../previewUrl/LinkPreviewPostCard";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import RecordNoImage from "../recordNotFound/RecordNoImage";
import CustomPopoverNew from "../CustomPopoverNew";
import SharePostPopup from "./SharePostPopup";
import {
  like_unlike_feed,
  add_feed_comment,
  update_feed_comment,
  like_unlike_feed_comment,
  delete_feed,
  delete_comment_api,
} from "../../DAL/feed/feed";
import CompanyPopup from "../popUp/CompanyPopup";
import CommentIcon from "../../assets/icon/CommentIcon";
import LikeIcon from "../../assets/icon/LikeIcon";
import { LikedIcon } from "../../assets/icon/LikedIcon";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  useLocation,
  useNavigate,
  useParams,
  useRouteError,
  useRoutes,
  useSearchParams,
} from "react-router-dom";
import CustomModalLayout from "../modal/CustomModalLayout";
import { linkify } from "../../utils/ConverHtml";
import ActionByChip from "./ActionByChip";

const PostCard = ({
  post,
  handleSelectedImage,
  getFeedsListingOnDelete,
  handleFeedEdit,
  selectedIndex,
  setSelectedIndex,
  previewLink,
  setPreviewLink,
  type,
  handleUpdateSpecificFeed,
}) => {
  const actionByName =
    post?.action_by?.company_name ||
    `${post?.action_by?.first_name || ""} ${post?.action_by?.last_name || ""}`;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const feedId = queryParams.get("feed_id");
  const deactivated = queryParams.get("deactivated");
  const params = useParams();
  const {
    userInfo,
    activeSourceList,
    findId,
    handleReportPost,
    handleGetActionByStatus,
  } = useIds();
  const [liked, setLiked] = useState(post?.is_liked);
  const [likedComment, setLikedComment] = useState(false);
  const [preview, setPreview] = useState(null);
  const [likeCount, setLikeCount] = useState(post?.like_count);
  const [commentCount, setCommentCount] = useState(post?.comment_count);
  const [companyModalOpen, setCompanyModalOpen] = useState(false);
  const [companyModalData, setCompanyModalData] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const textRef = React.useRef(null);

  const extractURL = (str) => {
    const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+\.[^\s]{2,})/gi;
    const match = str?.match(urlRegex);

    if (!match) return null;

    const url = match[0];
    return url.startsWith("www.") ? `https://${url}` : url;
  };
  const linkInDescription = extractURL(post?.description);

  const [comments, setComments] = useState(post?.latest_comments || []);
  const [commentsLikeCount, setCommentsLikeCount] = useState(0);
  const [commentText, setCommentText] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [showCommentBox, setShowCommentBox] = useState(false);
  const [isLoadingCom, setIsLoadingCom] = useState(false);
  const [open, setOpen] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [commentDialogue, setCommentDialogue] = useState(false);
  const [emojiPickerVisible, setEmojiPickerVisible] = useState(false);
  const [openDeleteComment, setOpenDeleteComment] = useState(false);
  const [selectedComment, setSelectedComment] = useState({});
  const [comment, setComment] = useState("");
  const [isEditing, setIsEditing] = useState(false); // Track if we're editing
  const [editingCommentIndex, setEditingCommentIndex] = useState(null);
  const [file, setFile] = useState("");
  const [feedComments, setFeedComments] = useState([]);
  const [openSharePost, setOpenSharePost] = useState(false);
  const [sharePostData, setSharePostData] = useState({});

  const measureRef = useRef(null);
  const [clampedText, setClampedText] = useState("");
  const [needsClamp, setNeedsClamp] = useState(false);

  const text = post?.description || "";

  const [isCommentAccessAllow, setIsCommentAccessAllow] = useState(
    (userInfo.role == "client" && !userInfo?.isCompanyProfile) ||
      (userInfo?.isCompanyProfile && userInfo?.company_access?.feed?.add)
  );

  const [isCommentUpdateAllow, setIsCommentUpdateAllow] = useState(
    (userInfo.role == "client" && !userInfo?.isCompanyProfile) ||
      (userInfo?.isCompanyProfile && userInfo?.company_access?.feed?.update)
  );

  // Check if text content exceeds 3 lines
  useEffect(() => {
    if (textRef.current && post?.description) {
      const element = textRef.current;
      const lineHeight = parseInt(window.getComputedStyle(element).lineHeight);
      const height = element.scrollHeight;
      const lines = Math.round(height / lineHeight);
      setShowReadMore(lines > 3);
    }
  }, [post?.description]);

  const handleLikeComment = async (comment, index) => {
    const isLiked = likedComment[index];

    setLikedComment((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));

    setCommentsLikeCount((prev) => ({
      ...prev,
      [index]: (prev[index] || 0) + (isLiked ? -1 : 1),
    }));

    const result = await like_unlike_feed_comment(comment._id);
    if (result.code === 200) {
      setComments((prevComments) =>
        prevComments.map((comment) =>
          comment._id === result?.feed_comment?._id
            ? result?.feed_comment
            : comment
        )
      );
      const newLikeCount = result.feed_comment.liked_by?.length;

      const isLikedByCurrentUser = result.feed_comment.liked_by?.some(
        (user) => user._id === userInfo._id
      );

      setCommentsLikeCount((prev) => ({
        ...prev,
        [index]: newLikeCount,
      }));

      setLikedComment((prev) => ({
        ...prev,
        [index]: isLikedByCurrentUser,
      }));
    } else {
      setLikedComment((prev) => ({
        ...prev,
        [index]: isLiked,
      }));

      setCommentsLikeCount((prev) => ({
        ...prev,
        [index]: Math.max(0, prev[index] + (isLiked ? 1 : -1)),
      }));
    }
  };

  const handleLike = async () => {
    setLiked(!liked);
    setLikeCount(liked ? likeCount - 1 : likeCount + 1);
    const result = await like_unlike_feed(post._id);
    if (result.code === 200) {
    }
  };

  const handleCommentToggle = () => {
    handleOpenDeatil();
    return;
    setIsEditing(false);
    setCommentText("");
    setPreview(null);
    setShowCommentBox(!showCommentBox);
  };

  const handleCommentSubmit = async (event) => {
    event.preventDefault();
    if (!commentText.trim() && !preview) {
      enqueueSnackbar("Comment cannot be empty!", { variant: "error" });
      return;
    }
    if (isEditing) {
      setIsLoadingCom(true);
      const formData = new FormData();
      formData.append("text", commentText);
      if (file) {
        formData.append("image", file);
      } else if (preview?.thumbnail_1) {
        formData.append("image", JSON.stringify(preview));
      } else {
        formData.append("image", "");
      }

      const result = await update_feed_comment(
        formData,
        editingCommentIndex._id
      );
      if (result.code === 200) {
        setComments((prevComments) =>
          prevComments.map((comment) =>
            comment._id === editingCommentIndex._id
              ? result?.feed_comment
              : comment
          )
        );
        setCommentText("");
        setPreview(null);
        setFile("");
        setEmojiPickerVisible(false);
        setIsLoadingCom(false);
        handleCancelEditComment();
      } else {
        setIsLoadingCom(false);
        enqueueSnackbar(result.message, { variant: "error" });
      }
    } else {
      setIsLoadingCom(true);
      const formData = new FormData();
      formData.append("feed_id", post._id);
      formData.append("text", commentText);
      if (file) {
        formData.append("image", file);
      }

      if (userInfo.isCompanyProfile) {
        formData.append("action_id", userInfo._id);
      }

      const result = await add_feed_comment(formData);
      if (result.code === 200) {
        setComments([result?.feed_comment, ...comments]);
        setCommentCount(commentCount + 1);

        setFeedComments([result?.feed_comment, ...comments]);
        setLikedComment((prev) => ({
          [0]: false,
          ...Object.fromEntries(
            Object.entries(prev).map(([k, v]) => [parseInt(k) + 1, v])
          ),
        }));
        setCommentsLikeCount((prev) => ({
          [0]: 0,
          ...Object.fromEntries(
            Object.entries(prev).map(([k, v]) => [parseInt(k) + 1, v])
          ),
        }));
        setCommentText("");
        setPreview(null);
        setFile("");
        setEmojiPickerVisible(false);
        setIsLoadingCom(false);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoadingCom(false);
      }
    }
  };
  const handleDeleteFeed = async () => {
    setOpenDelete(false);
    const result = await delete_feed(post._id);
    if (result.code === 200) {
      enqueueSnackbar("Post deleted successfully", { variant: "success" });
      getFeedsListingOnDelete(post._id);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleCommentDeleteConfirmation = (selected_comment) => {
    setOpenDeleteComment(true);
    setSelectedComment(selected_comment);
  };

  const handleImageUpload = (event) => {
    if (!event.target?.files || event.target.files.length === 0) {
      console.error("No file selected!");
      return;
    }

    const file = event.target.files[0];
    setFile(file);
    setPreview(URL.createObjectURL(file));

    event.target.value = "";
  };

  const handleEditComment = (comment, index) => {
    setIsEditing(true);
    setShowCommentBox(true);
    setEditingCommentIndex(comment);
    setCommentText(comment.text);
    setPreview(
      comment?.comment_image?.thumbnail_1 ? comment?.comment_image : null
    );
  };

  const handleCancelEditComment = () => {
    setIsEditing(false);
    setShowCommentBox(false);
    setEditingCommentIndex(null);
    setCommentText("");
    setPreview("");
  };

  const handleOpenDeatil = () => {
    setOpen(true);
    setPreview(null);
    setCommentText("");
  };
  const handleDialogueOpen = () => {
    setLogoutDialogOpen(true);
  };
  const handleCommentDialogueOpen = () => {
    setCommentDialogue(true);
  };

  const handleComment = () => {
    setCommentDialogue(false);
    // enqueueSnackbar("comment deleted successfully.", { variant: "success" });
  };
  const handleEmojiClick = (emojiData) => {
    setCommentText((prevComment) => prevComment + emojiData.native);
  };

  const handleLogout = () => {
    setLogoutDialogOpen(false);
    // enqueueSnackbar("postpost deleted successfully.", { variant: "success" });
  };

  const handleClose = () => {
    setOpen(false);
    setEmojiPickerVisible(false);
    setComment("");
    setCommentText("");
    setPreview(null);
    handleCancelEditComment();

    if (feedId) {
      // Remove feed_id from URL
      queryParams.delete("feed_id");
      if (deactivated == "true") {
        getFeedsListingOnDelete(feedId);
        queryParams.delete("deactivated");
      }
      navigate({
        pathname: location.pathname,
        search: queryParams.toString(),
      });
    }
  };

  const handleClickImage = (event, index, path) => {
    if (!handleSelectedImage) {
      handleOpenDeatil();
      return;
    }
    console.log("object");
    handleSelectedImage(post, index);
    setOpen(true);
    setPreview(null);
    setCommentText("");
  };

  const handleDeleteFeedConfirmation = (value) => {
    setOpenDelete(true);
  };
  const handleNavigateReportPage = (value) => {
    // if (params.source_slug) {
    //   navigate(`/${params.source_slug}/report/post/${value._id}`);
    // } else {
    //   navigate(`/home/report/post/${value._id}`);
    // }

    handleReportPost(value, "Post", handleReportPostSuccess);
  };
  const handleReportComment = (value) => {
    handleReportPost(value, "feed_comment", () => handleFilterComments(value));
  };

  const handleFilterComments = (targetComment) => {
    setComments((prevComments) =>
      prevComments.filter((comment) => comment._id !== targetComment._id)
    );
    setCommentCount(commentCount - 1);
  };

  const handleReportPostSuccess = (id) => {
    getFeedsListingOnDelete(id);
    handleClose();
  };

  const imageLinks = {
    docx: wordImage,
    mp3: audioImage,
    pdf: pdfImage,
    csv: csvImage,
    doc: docImage,
    xlsx: xlsxImage,
    xls: xlsxImage,
    other: otherImage,
  };
  const getCommentImage = (file) => {
    if (file.type === "file") {
      const ext = file.path.name.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return URL.createObjectURL(file.path);
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    } else {
      const ext = file.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return s3baseUri + file;
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    }
  };

  const handleDeleteComment = async () => {
    setOpenDeleteComment(false);
    const result = await delete_comment_api(selectedComment._id);
    if (result.code === 200) {
      setComments((prevComments) =>
        prevComments.filter((comment) => comment._id !== selectedComment._id)
      );
      setCommentCount(commentCount - 1);

      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleMenu = (row) => {
    let MENU_OPTIONS = [];
    if (userInfo?.profile_id === post?.created_by?._id) {
      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.feed?.update &&
          (userInfo?._id == post?.action_by?._id ||
            userInfo?.company_access?.feed?.global_access))
      ) {
        MENU_OPTIONS.push({
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick: () => {
            handleFeedEdit(row);
          },
        });
      }
      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.feed?.delete &&
          (userInfo?._id == post?.action_by?._id ||
            userInfo?.company_access?.feed?.global_access))
      ) {
        MENU_OPTIONS.push({
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: handleDeleteFeedConfirmation,
        });
      }
    } else {
      MENU_OPTIONS.push({
        label: "Report",
        icon: "material-symbols:report-outline",
        handleClick: () => {
          handleNavigateReportPage(row);
        },
        color: "error",
      });
    }
    return MENU_OPTIONS;
  };

  const handleMenucomments = (row) => {
    let MENU_OPTIONS1 = [];
    if (userInfo?.profile_id === row?.commented_by?._id) {
      if (
        (userInfo.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.feed?.update &&
          (userInfo?._id == row?.action_by?._id ||
            userInfo?.company_access?.feed?.global_access))
      ) {
        MENU_OPTIONS1.push({
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick: () => handleEditComment(row),
        });
      }

      if (
        (userInfo.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.feed?.delete &&
          (userInfo?._id == row?.action_by?._id ||
            userInfo?.company_access?.feed?.global_access))
      ) {
        MENU_OPTIONS1.push({
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: () => {
            handleCommentDeleteConfirmation(row);
          },
        });
      }
    } else {
      MENU_OPTIONS1.push({
        label: "Report Comment",
        icon: "material-symbols:report-outline",
        handleClick: () => {
          handleReportComment(row);
        },
        color: "error",
      });
    }

    return MENU_OPTIONS1;
  };

  // For post creator profile
  const handleCompanyNameClick = () => {
    // setCompanyModalData(post?.created_by);
    // setCompanyModalOpen(true);
    navigate("/user/" + post?.created_by._id);
  };
  // For commenter's profile
  const handleCommentCompanyClick = (comment) => {
    setCompanyModalData(comment?.commented_by);
    setCompanyModalOpen(true);
  };

  const handleCloseCompanyModal = () => {
    setCompanyModalOpen(false);
  };

  useEffect(() => {
    // if (post?.liked_by?.length > 0) {
    //   const isLiked = post.liked_by?.some((user) => user._id === userInfo?._id);
    //   setLiked(isLiked);
    // }
    if (post?.latest_comments?.length > 0) {
      const likedComments = post.latest_comments.reduce((acc, item, index) => {
        acc[index] = item.liked_by?.some((user) => user._id === userInfo?._id);
        return acc;
      }, {});

      const likedCounts = post.latest_comments.reduce((acc, item, index) => {
        acc[index] = item.liked_by?.length;
        return acc;
      }, {});

      setCommentsLikeCount(likedCounts);
      setLikedComment(likedComments);
    }
  }, [post]);
  const parseDescriptionWithLink = (description) => {
    // Regex to match:
    // 1. http://..., https://...
    // 2. www.example.com (but not just "www" alone)
    const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+\.[^\s]{2,})/gi;
    const parts = description.split(urlRegex);

    return parts
      .map((part, index) => {
        if (!part) return null; // Skip empty parts

        // Check if part is a URL (either http(s):// or www.xxx.yyy)
        const isHttpUrl = /^https?:\/\//i.test(part);
        const isWwwUrl = /^www\.[^\s]+\.[^\s]{2,}/i.test(part); // Ensures "www.x.y" format

        if (isHttpUrl || isWwwUrl) {
          const url = isWwwUrl ? `https://${part}` : part; // Add https:// if www. URL
          return (
            <a
              key={index}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1976d2", textDecoration: "underline" }}
              onClick={(e) => e.stopPropagation()}
            >
              {part}
            </a>
          );
        }

        return <span key={index}>{part}</span>;
      })
      .filter(Boolean); // Remove null entries
  };

  // Share URL logic
  const postDetailUrl = `${window.location.origin}/post/${post._id}`;

  // Build a robust share text for all post types
  let shareTextParts = [];
  if (post?.description) shareTextParts.push(post.description);
  if (post?.video_url) shareTextParts.push(`Video: ${post.video_url}`);
  if (post?.feed_type === "image" && post?.media && post.media.length > 0) {
    const imageUrls = post.media.map((img) =>
      img?.thumbnail_1?.startsWith("http")
        ? img.thumbnail_1
        : s3baseUri + img.thumbnail_1
    );
    shareTextParts.push(`Images: ${imageUrls.join(", ")}`);
  }
  if (post?.feed_type === "document" && post?.media?.length > 0) {
    const docUrls = post.media.map((doc) =>
      doc.startsWith("http") ? doc : s3baseUri + doc
    );
    shareTextParts.push(`Documents: ${docUrls.join(", ")}`);
  }
  shareTextParts.push(postDetailUrl);

  const [shareAnchorEl, setShareAnchorEl] = useState(null);

  const handleShareClick = (post) => {
    setOpenSharePost(true);
    setSharePostData(post);
  };

  const handleShareClose = () => {
    setShareAnchorEl(null);
  };

  useEffect(() => {
    // Facebook SDK load karein
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "724262789278150",
        cookie: true,
        xfbml: true,
        version: "v18.0",
      });
    };

    // SDK script load
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    document.head.appendChild(script);
  }, []);

  const sharePopoverOpen = Boolean(shareAnchorEl);

  useEffect(() => {
    const el = measureRef.current;
    if (!el) return;

    const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
    const maxHeight = lineHeight * 3; // Maximum height for 3 lines

    // Step 1: Set full text to measure total height
    el.innerText = text;
    const fullHeight = el.scrollHeight;

    // If text fits in <= 3 lines → no "view more"
    if (fullHeight <= maxHeight) {
      setNeedsClamp(false);
      setClampedText(text);
      return;
    }

    // Otherwise, we need to clamp the text
    setNeedsClamp(true);

    // ---- Binary search to find best fitting cutoff ----
    let low = 0;
    let high = text.length;
    let bestFit = text;

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      el.innerText = text.slice(0, mid);

      if (el.scrollHeight <= maxHeight) {
        bestFit = text.slice(0, mid);
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    // Remove partial last word
    bestFit = bestFit.replace(/\s+\S*$/, "");

    setClampedText(bestFit);
  }, [text]);

  useEffect(() => {
    if (feedId && feedId == post._id) {
      handleOpenDeatil();
    }
  }, [feedId]);

  useEffect(() => {
    setLikeCount(post.like_count);
    setCommentCount(post.comment_count);
  }, [post]);

  return (
    <>
      <CustomConfirmation
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        title={"Are you sure you want to delete this post?"}
        headerHeading={"Delete Post"}
        handleAgree={handleDeleteFeed}
      />
      <CustomConfirmation
        openDelete={openDeleteComment}
        setOpenDelete={setOpenDeleteComment}
        title={"Are you sure you want to delete this comment?"}
        headerHeading={"Delete Comment"}
        handleAgree={handleDeleteComment}
      />

      {/* Single feed item box starts here */}
      <div className="feed-box-wrapper mb-3">
        <CardContent className="feed-box-item card-1">
          <div className="feed-profile-info d-flex flex-nowrap align-items-center">
            <Avatar
              className="profile-img hover-primary"
              onClick={handleCompanyNameClick}
              src={s3baseUri + post?.created_by?.profile_image?.thumbnail_1}
            />

            <div className="profile-info w-100">
              <div className="profile-name-top d-flex align-items-center justify-content-between">
                <div
                  className="profile-name hover-primary"
                  onClick={handleCompanyNameClick}
                >
                  <span>{post?.created_by?.company_name}</span>
                </div>
                <div className="d-flex align-items-center gap-0">
                  {handleGetActionByStatus(post, "feed") && (
                    <ActionByChip
                      className="new-chip new-chip--outlined tw-text-[12px] tw-leading-[16px] tw-h-[20px] mt-2 tw-mx-0"
                      actionByName={actionByName}
                    />
                  )}
                  {handleMenu(post).length > 0 && (
                    <div className="three-dots-menu">
                      <CustomPopover menu={handleMenu(post)} data={post} />
                    </div>
                  )}
                </div>
              </div>
              <div className="sector-date-info d-flex align-items-center">
                <span className="sector-info golden-chip">
                  {post?.source?.title || ""}
                </span>
                <span className="feed-date grey-text medium-text ms-2">
                  {moment(post.published_time).fromNow()}
                </span>
              </div>
            </div>
          </div>
          <div className="content-comment-wrapper">
            {/* Feed profile section ends here */}
            <div className="feed-content">
              <div
                ref={measureRef}
                className="feed-description"
                style={{
                  position: "absolute",
                  visibility: "hidden",
                  whiteSpace: "pre-line",
                }}
              />

              <div className="feed-description" onClick={handleOpenDeatil}>
                {!expanded ? (
                  <p style={{ whiteSpace: "pre-line" }}>
                    {linkify(clampedText)}{" "}
                    {needsClamp && (
                      <span
                        className="read-more-text"
                        onClick={(e) => {
                          e.stopPropagation(); // prevent navigation
                          setExpanded(true);
                        }}
                      >
                        ...more
                      </span>
                    )}
                  </p>
                ) : (
                  <p style={{ whiteSpace: "pre-line" }}>
                    {linkify(text)}
                    <p
                      className="read-more-text"
                      onClick={(e) => {
                        e.stopPropagation(); // prevent navigation
                        setExpanded(false);
                      }}
                    >
                      ...less
                    </p>
                  </p>
                )}
              </div>

              {linkInDescription &&
                post?.is_link_preview &&
                post.feed_type !== "image" &&
                post.feed_type !== "document" &&
                post.feed_type !== "video" && (
                  <div className="link-preview-section">
                    <PreviewPostCard
                      text={linkInDescription}
                      type={"icon_close"}
                      post={post}
                      state={false}
                      previewLink={previewLink}
                      setPreviewLink={setPreviewLink}
                      typeData={type}
                    />
                  </div>
                )}

              <div className={linkInDescription ? "col-12 mt-2" : "col-12"}>
                {post.feed_type === "image" && post.media.length > 0 && (
                  <div className="feed-image pointer image-block">
                    <FeedImagesList
                      feed_images={post.media}
                      handleClickImage={handleClickImage}
                    />
                  </div>
                )}
                {post?.feed_type === "document" && post?.media?.length > 0 && (
                  <div className="feed-image document_img my-3 doc-block">
                    {post.media.map((item) => {
                      return (
                        <a
                          target="_blank"
                          href={s3baseUri + item}
                          className="pointer"
                        >
                          <img
                            className="img-fluid"
                            src={getCommentImage(item)}
                          />
                        </a>
                      );
                    })}
                  </div>
                )}
                {post.feed_type === "video" && post.video_url && (
                  <div className="feed-image mt-3 video-block">
                    <ReactVideoPlayer url={post.video_url} />
                  </div>
                )}
              </div>
            </div>

            {(likeCount > 0 || commentCount > 0) && (
              <div className="like-comment-count">
                <div className="grey-text d-flex justify-content-between col-12">
                  {likeCount > 0 && (
                    <span className="like-counts d-flex align-items-center">
                      <img src={liked_counts_icon} alt="liked_counts_icon" />
                      <span className="ms-1">{likeCount}</span>
                    </span>
                  )}

                  {commentCount > 0 && (
                    <span
                      className="comments-count d-flex align-items-center"
                      onClick={handleOpenDeatil}
                    >
                      <span>{commentCount} Comments</span>
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Like/Comment/Share icons box starts here */}
          <div className="engagement-buttons d-flex justify-content-around">
            {/* like/unlike Icon */}

            {liked ? (
              <button
                className={`like-btn grey-text semi-bold`}
                onClick={handleLike}
              >
                <img
                  src={liked_icon}
                  className="engagement-icon"
                  style={{ height: 20 }}
                  alt="like_icon"
                />
                <span className="liked">Liked</span>
              </button>
            ) : (
              <button
                className={`like-btn grey-text semi-bold`}
                onClick={handleLike}
              >
                <img
                  src={like_icon}
                  className="engagement-icon"
                  style={{ height: 20 }}
                  alt="like_icon"
                />
                <span>Like</span>
              </button>
            )}

            {/* Comment Icon code starts here */}
            <button
              className="comment-btn grey-text semi-bold"
              // onClick={
              //   userInfo.role == "client" ? handleCommentToggle : undefined
              // }
              // disabled={userInfo.role == "candidate"}
              onClick={handleOpenDeatil}
            >
              {/* <Icon icon="iconamoon:comment-bold" className="engagement-icon" /> */}
              <img
                src={comment_icon}
                className="engagement-icon"
                style={{ height: 18 }}
                alt="comment_icon"
              />
              <span>Comment</span>
            </button>

            {/* Share icon code starts here */}
            {/* <Tooltip
              title={!post.description ? "Description required to share" : ""}
              placement="top"
              disableHoverListener={!!post.description}
              arrow
            > */}
            <button
              className="share-btn grey-text semi-bold"
              onClick={() => handleShareClick(post)}
              // disabled={!post.description}
            >
              <img
                src={share_icon}
                className="engagement-icon"
                style={{ height: 18 }}
                alt="share_icon"
              />
              <span>Share</span>
            </button>
            {/* </Tooltip> */}
            {/* share icon code ends here */}

            <CustomModalLayout
              open={openSharePost}
              onClose={() => setOpenSharePost(false)}
              title="Share Post"
              width="550px"
              componentToPass={
                <SharePostPopup postData={sharePostData} type="feed" />
              }
            />
            {showCommentBox && userInfo.role == "client" && (
              <Box p={1} sx={{ borderRadius: 2, paddingTop: "0px" }}>
                <form onSubmit={handleCommentSubmit}>
                  <TextField
                    rows={2}
                    multiline
                    fullWidth
                    variant="outlined"
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    label={
                      isEditing ? "Edit your comment" : "Write a comment..."
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        paddingTop: "5px",
                        paddingBottom: "4px",
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "4px 8px",
                      },
                    }}
                  />

                  <div className="post-button mt-0">
                    <Box
                      mt={1}
                      display="flex"
                      justifyContent="space-between"
                      sx={{
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <div className="d-flex">
                        {(preview || preview?.thumbnail_1) && (
                          <div
                            style={{
                              padding: "4px",
                              borderRadius: "5px",
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              maxWidth: "fit-content",
                              position: "relative",
                              border: "1px solid #ddd",
                              background: "#fff",
                            }}
                          >
                            <span
                              onClick={() => setPreview(null)}
                              style={{
                                cursor: "pointer",
                                background: "red",
                                color: "white",
                                borderRadius: "50%",
                                width: "15px",
                                height: "15px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "10px",
                                fontWeight: "bold",
                                position: "absolute",
                                top: "-8px",
                                right: "-8px",
                                zIndex: 2,
                                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                              }}
                            >
                              ✖
                            </span>
                            <img
                              src={
                                typeof preview === "string" &&
                                preview.startsWith("blob:")
                                  ? preview
                                  : s3baseUri + preview?.thumbnail_1
                              }
                              alt="Preview"
                              style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "5px",
                                objectFit: "cover",
                                position: "relative",
                              }}
                            />
                          </div>
                        )}
                        <IconButton component="label">
                          <input
                            type="file"
                            id="imageInput"
                            style={{ display: "none" }}
                            accept="image/*"
                            onChange={handleImageUpload}
                            disabled={userInfo.role == "candidate"}
                          />
                          {!preview && (
                            <AddPhotoAlternateOutlinedIcon
                              sx={{
                                color: "#daa520",
                                opacity: userInfo.role == "candidate" ? 0.5 : 1,
                              }}
                            />
                          )}
                        </IconButton>
                      </div>

                      <button
                        className="small-button-cotain-post"
                        type="submit"
                        disabled={isLoadingCom || userInfo.role == "candidate"}
                        style={{
                          width: "100%",
                          maxWidth: "150px",
                          marginTop: { xs: "8px", sm: "0px" },
                          opacity:
                            isLoadingCom || userInfo.role == "candidate"
                              ? 0.6
                              : 1,
                          cursor:
                            isLoadingCom || userInfo.role == "candidate"
                              ? "not-allowed"
                              : "pointer",
                          pointerEvents:
                            isLoadingCom || userInfo.role == "candidate"
                              ? "none"
                              : "auto",
                        }}
                      >
                        {isLoadingCom
                          ? isEditing
                            ? "Updating..."
                            : "Posting..."
                          : isEditing
                          ? "Update"
                          : "Post Comment"}
                      </button>
                    </Box>
                  </div>
                </form>
              </Box>
            )}
          </div>
          {/* Like/Comment/Share icons box ENDS here */}

          {open && (
            <PostDetalPage
              setCompanyModalData={setCompanyModalData}
              handleCompanyNameClick={handleCompanyNameClick}
              handleCommentCompanyClick={handleCommentCompanyClick}
              companyModalData={companyModalData}
              feedComments={feedComments}
              parseDescriptionWithLink={parseDescriptionWithLink}
              setFeedComments={setFeedComments}
              open={open}
              post={post}
              onClose={handleClose}
              expanded={expanded}
              setExpanded={setExpanded}
              handleMenu={handleMenu}
              handleLike={handleLike}
              liked={liked}
              likeCount={likeCount}
              comments={comments}
              setComment={setComment}
              setComments={setComments}
              setLiked={setLiked}
              handleMenucomments={handleMenucomments}
              isLoadingCom={isLoadingCom}
              setCommentsLikeCount={setCommentsLikeCount}
              selectedImageIndex={selectedIndex}
              commentCount={commentCount}
              setCommentCount={setCommentCount}
              commentsLikeCount={commentsLikeCount}
              handleLikeComment={handleLikeComment}
              likedComment={likedComment}
              setLikedComment={setLikedComment}
              handleCommentLike={handleLikeComment}
              handleCommentSubmit={handleCommentSubmit}
              linkInDescription={linkInDescription}
              // feedComments={feedComments}
              // setFeedComments={setFeedComments}
              emojiPickerVisible={emojiPickerVisible}
              setEmojiPickerVisible={setEmojiPickerVisible}
              comment={comment}
              handleEmojiClick={handleEmojiClick}
              handleImageUpload={handleImageUpload}
              preview={preview}
              setPreview={setPreview}
              setCommentText={setCommentText}
              commentText={commentText}
              handleEditComment={handleEditComment}
              setIsEditing={setIsEditing}
              handleCancelEditComment={handleCancelEditComment}
              handleFeedEdit={handleFeedEdit}
              isEditing={isEditing}
              handleShareClick={handleShareClick}
              setShowReadMore={setShowReadMore}
              showReadMore={showReadMore}
              isCommentAccessAllow={isCommentAccessAllow}
              isCommentUpdateAllow={isCommentUpdateAllow}
              handleUpdateSpecificFeed={handleUpdateSpecificFeed}
              previewLink={previewLink}
              setPreviewLink={setPreviewLink}
              type={type}
            />
          )}
        </CardContent>
      </div>
      {/* Company Profile Modal (for post creator or commenter) */}

      <CompanyPopup
        companyModalOpen={companyModalOpen}
        handleCloseCompanyModal={handleCloseCompanyModal}
        companyModalData={companyModalData}
      />
    </>
  );
};

export default PostCard;
